import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AppSettings } from '../../providers/app-settings';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  menuOptions: any;
  currentPage: string;

  constructor(private router: Router, private appSettings: AppSettings) { }

  ngOnInit() {
    this.menuOptions = {
      gym: 'Gyms',
      tracker: 'Trackers',
      trackerPair: 'Tracker Pairs',
      classTemplate: 'Class templates',
      groupClass: 'Group classes',
      activity: 'Activities',
      exercise: 'Exercises',
      assets: 'Assets',
      user: 'Users',
      logout: 'Logout'
    };
    this.currentPage = 'gym';
  }

  isCurrentPage(option) {
    if (option === this.currentPage) {
      return true;
    }
    return false;
  }

  goTo(option): void {
    if (option === 'logout') {
      this.logout();
    } else {
      this.router.navigate(['/' + option + '/']);
    }
    this.currentPage = option;
  }

  logout() {
    this.appSettings.apiHeaders.set('X-Access-Token', null);
    this.appSettings.setLoginStatus(false);
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/menu/menu.component.ts